import React from 'react';
import { identity, isEmpty } from 'ramda';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Container, Label } from './pill.styles';
import { renderWhenTrue } from '../../utils/rendering';

export const Pill = ({ renderIcon, placeholderMessage, message, onClick, primary, className, disabled }) => {
  const handleClick = () => {
    if (disabled) {
      return;
    }

    onClick();
  };

  return (
    <Container disabled={disabled} onClick={handleClick} className={className} primary={primary}>
      <Label>
        {renderWhenTrue(() => <FormattedMessage {...(isEmpty(message) ? placeholderMessage : message)} />)(
          !isEmpty(placeholderMessage) || !isEmpty(message)
        )}
      </Label>
      {renderIcon(null)}
    </Container>
  );
};

Pill.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  message: PropTypes.object,
  placeholderMessage: PropTypes.object,
  primary: PropTypes.bool,
  renderIcon: PropTypes.func,
  onClick: PropTypes.func.isRequired,
};

Pill.defaultProps = {
  placeholderMessage: {},
  message: {},
  primary: false,
  renderIcon: identity,
};
